import React from 'react';

export const OpenIcon = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8783 10.3431L25.192 6.80757L21.6564 18.1213"
          stroke="#0099C7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1217 21.6569L6.80794 25.1923L10.3436 13.8787"
          stroke="#0099C7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="0.75"
          y="0.75"
          width="30.5"
          height="30.5"
          rx="3.25"
          stroke="#0099C7"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <rect
          x="16"
          y="13.1716"
          width="4"
          height="4"
          rx="2"
          transform="rotate(45 16 13.1716)"
          stroke="#0099C7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
